import {
  withFormsy,
} from 'formsy-react';

import InputNumberView from './InputNumberView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputNumberView);

const Component = InputComponent;

export default Component;
